export enum ModalTypes {
  OPEN = '@modal/OPEN',
  CLOSE = '@modal/CLOSE',
}
